import _slicedToArray from "/home/soutaito/projects/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/home/soutaito/projects/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/soutaito/projects/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.push.js";
var __default__ = {
  head: {
    title: function title() {
      return {
        inner: this.pageTitle
      };
    },
    meta: []
  }
};
import { ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router/composables";
import { useStore } from "vue2-helpers/vuex";
import { useFileDialog } from "@vueuse/core";
import LoadingMessage from "@/components/common/LoadingMessage.vue";
import ConfirmSlotModal from "@/components/common/ConfirmSlotModal.vue";
import MessageModal from "@/components/common/MessageModal.vue";
import RowItem from "@/components/RowItem.vue";
import { getData, createData } from "@/services/axios";
import { useMessageUrlValidator } from "@/composables/messageUrlValidator";
export default /*#__PURE__*/Object.assign(__default__, {
  __name: 'ForumEdit',
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    // @ts-check
    var route = useRoute();
    var router = useRouter();
    var store = useStore();
    var isLoading = ref(false);
    var loadMessage = "";
    var isCreate = computed(function () {
      return !route.params.id;
    });
    var pageTitle = computed(function () {
      return isCreate.value ? "記事作成" : "記事編集";
    });
    var title = ref("");
    var message = ref("");
    var s3AttachedPath = ref("");
    var fileName = ref("");

    var _useMessageUrlValidat = useMessageUrlValidator(message),
        isUrlValidate = _useMessageUrlValidat.isUrlValidate;

    var setData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _forumData$message, data, forumData;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                isLoading.value = true;
                _context.next = 4;
                return getData("school_forums/".concat(route.params.id));

              case 4:
                data = _context.sent;
                forumData = data.items;
                title.value = forumData.title;
                message.value = (_forumData$message = forumData.message) !== null && _forumData$message !== void 0 ? _forumData$message : "";

                if (forumData.attachment[0]) {
                  s3AttachedPath.value = forumData.attachment[0].object_key;
                  fileName.value = forumData.attachment[0].file_name;
                }

                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0);
                isLoading.value = true;

              case 15:
                _context.prev = 15;
                isLoading.value = false;
                return _context.finish(15);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 11, 15, 18]]);
      }));

      return function setData() {
        return _ref2.apply(this, arguments);
      };
    }();

    var getS3UrlStatusRunning = ref(false);
    var getS3UrlStatus = ref("内容を確認");

    var getS3SignedUrl = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var newWindow, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                getS3UrlStatus.value = "お待ち下さい";
                getS3UrlStatusRunning.value = true; //secure browserのpopup block 対策

                newWindow = window.open();
                _context2.prev = 3;
                _context2.next = 6;
                return getData("reader/get_s3_signed_url?path=" + encodeURIComponent(s3AttachedPath.value));

              case 6:
                data = _context2.sent;
                newWindow.location = data.items.s3url;
                getS3UrlStatus.value = "内容を確認";
                getS3UrlStatusRunning.value = false;
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](3);
                console.log(_context2.t0);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[3, 12]]);
      }));

      return function getS3SignedUrl() {
        return _ref3.apply(this, arguments);
      };
    }();

    var error = ref(
    /** @type {Map<"title" | "message", string>} */
    new Map([["title", ""], ["message", ""]]));

    var validateMessage = function validateMessage() {
      // エラーの状態をデフォルトに戻す
      error.value = new Map([["title", ""], ["message", ""]]);
      var valid = true;

      if (!title.value) {
        error.value.set("title", "掲示板のタイトルを入力してください。");
        valid = false;
      } else if (title.value.length > 100) {
        "掲示板のタイトルは100文字以内で入力してください。";
        error.value.set("title", "掲示板のタイトルは100文字以内で入力してください。");
        valid = false;
      }

      if (message.value.length > 3000) {
        error.value.set("message", "メッセージ本文は3000文字以内で入力してください。");
        valid = false;
      }

      return valid;
    };

    var errorTotalText = computed(function () {
      var text = "";
      error.value.forEach(function (value) {
        if (value) {
          text += "".concat(value, "\n");
        }
      });
      return text;
    });
    /** @type {Ref<File | null>} */

    var attachment = ref(null);
    var attachmentError = ref("");

    var _useFileDialog = useFileDialog({
      multiple: false
    }),
        open = _useFileDialog.open,
        reset = _useFileDialog.reset,
        onChange = _useFileDialog.onChange;

    onChange(function (files) {
      if (checkFile(files[0])) {
        attachment.value = files[0];
        attachmentError.value = "";
      } else {
        reset();
      }
    });

    var checkFile = function checkFile(file) {
      //拡張子はpdf, jpg, jpeg, png, gif
      var fileName = file.name;

      if (!(fileName.endsWith(".pdf") || fileName.endsWith(".jpg") || fileName.endsWith(".jpeg") || fileName.endsWith(".png") || fileName.endsWith(".gif"))) {
        attachmentError.value = "ファイルの種類が不正です。添付できるファイルの種類はpdf, jpg, jpeg, png, gifです。";
        return false;
      } //サイズは5MBまで


      if (file.size > 5242880) {
        attachmentError.value = "ファイルサイズが5MBを超えています。添付できるファイルのサイズは5MB以下です。";
        return false;
      }

      return true;
    }; // input type=file 側の unset


    var unsetAttachment = function unsetAttachment() {
      reset();
      attachment.value = null;
    };

    var isShowUnsetAttachmentConfirmModal = ref(false);

    var showUnsetAttachmentConfirmModal = function showUnsetAttachmentConfirmModal() {
      isShowUnsetAttachmentConfirmModal.value = true;
    };

    var hideUnsetAttachmentConfirmModal = function hideUnsetAttachmentConfirmModal() {
      isShowUnsetAttachmentConfirmModal.value = false;
    }; // s3 パスの unset


    var unsetS3Attachment = function unsetS3Attachment() {
      s3AttachedPath.value = "";
      hideUnsetAttachmentConfirmModal();
    };

    var isShowConfirmModal = ref(false);
    var isShowCompleteModal = ref(false);

    var checkMessageConfirm = function checkMessageConfirm() {
      if (!validateMessage()) {
        return false;
      }

      isShowConfirmModal.value = true;
    };

    var hideConfirmModal = function hideConfirmModal() {
      isShowConfirmModal.value = false;
    };

    var createEditForum = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var payload, formData;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                /** @type {{ title: string; message: string; attachment?: File; file_name?: string }} */
                payload = {
                  title: title.value,
                  message: message.value
                };

                if (attachment.value) {
                  // 添付ファイル作成
                  payload.attachment = attachment.value;
                  payload.file_name = attachment.value.name;
                }

                formData = new FormData();
                Object.entries(payload).forEach(function (_ref5) {
                  var _ref6 = _slicedToArray(_ref5, 2),
                      key = _ref6[0],
                      value = _ref6[1];

                  formData.append(key, value);
                });
                _context3.prev = 4;
                isLoading.value = true;

                if (!isCreate.value) {
                  _context3.next = 12;
                  break;
                }

                _context3.next = 9;
                return createData("school_forums", formData);

              case 9:
                store.dispatch("commitModalMessage", {
                  message: "記事の投稿が完了しました",
                  title: "投稿完了"
                });
                _context3.next = 17;
                break;

              case 12:
                if (!s3AttachedPath.value && !attachment.value) {
                  formData.append("delete", "true");
                } // 素のputではformdataが使えなかったのでmethodを指定しつつpostする


                formData.append("_method", "put");
                _context3.next = 16;
                return createData("school_forums/".concat(route.params.id), formData);

              case 16:
                store.dispatch("commitModalMessage", {
                  message: "記事を編集しました",
                  title: "編集完了"
                });

              case 17:
                isShowCompleteModal.value = true;
                _context3.next = 24;
                break;

              case 20:
                _context3.prev = 20;
                _context3.t0 = _context3["catch"](4);
                console.log(_context3.t0);

                if (_context3.t0.response.status === 406) {
                  attachmentError.value = "ファイルの種類が不正です。添付できるファイルの種類はpdf, jpg, jpeg, png, gifです。";
                }

              case 24:
                _context3.prev = 24;
                isShowConfirmModal.value = false;
                isLoading.value = false;
                return _context3.finish(24);

              case 28:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[4, 20, 24, 28]]);
      }));

      return function createEditForum() {
        return _ref4.apply(this, arguments);
      };
    }();

    var completeCreate = function completeCreate() {
      isShowCompleteModal.value = false;
      router.push({
        name: "forums"
      });
    }; // created


    if (!isCreate.value) {
      // 編集の時だけデータを取得する
      setData();
    }

    expose({
      pageTitle: pageTitle
    });
    return {
      __sfc: true,
      route: route,
      router: router,
      store: store,
      isLoading: isLoading,
      loadMessage: loadMessage,
      isCreate: isCreate,
      pageTitle: pageTitle,
      title: title,
      message: message,
      s3AttachedPath: s3AttachedPath,
      fileName: fileName,
      isUrlValidate: isUrlValidate,
      setData: setData,
      getS3UrlStatusRunning: getS3UrlStatusRunning,
      getS3UrlStatus: getS3UrlStatus,
      getS3SignedUrl: getS3SignedUrl,
      error: error,
      validateMessage: validateMessage,
      errorTotalText: errorTotalText,
      attachment: attachment,
      attachmentError: attachmentError,
      open: open,
      reset: reset,
      onChange: onChange,
      checkFile: checkFile,
      unsetAttachment: unsetAttachment,
      isShowUnsetAttachmentConfirmModal: isShowUnsetAttachmentConfirmModal,
      showUnsetAttachmentConfirmModal: showUnsetAttachmentConfirmModal,
      hideUnsetAttachmentConfirmModal: hideUnsetAttachmentConfirmModal,
      unsetS3Attachment: unsetS3Attachment,
      isShowConfirmModal: isShowConfirmModal,
      isShowCompleteModal: isShowCompleteModal,
      checkMessageConfirm: checkMessageConfirm,
      hideConfirmModal: hideConfirmModal,
      createEditForum: createEditForum,
      completeCreate: completeCreate,
      LoadingMessage: LoadingMessage,
      ConfirmSlotModal: ConfirmSlotModal,
      MessageModal: MessageModal,
      RowItem: RowItem
    };
  }
});